import { render } from "./Apply.vue?vue&type=template&id=3898313c&scoped=true"
import script from "./Apply.vue?vue&type=script&lang=js"
export * from "./Apply.vue?vue&type=script&lang=js"

import "./Apply.vue?vue&type=style&index=0&id=3898313c&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-3898313c"

export default script